export const PROFILE_TAGLINE_MAX_LENGTHApi = 100;
export const PROFILE_DESCRIPTION_MIN_LENGTHApi = 100;
export const PROFILE_DESCRIPTION_MAX_LENGTHApi = 3000;
export const COVER_IMAGE_WIDTHApi = 1920;
export const COVER_IMAGE_HEIGHTApi = 550;
export const NARROW_PROFILE_COVER_IMAGE_HEIGHTApi = 350;
export const COVER_IMAGE_DESCRIPTION_MAX_LENGTHApi = 256;
export const COVER_IMAGE_MAX_DIMENSIONApi = 3840;
export const PROFILE_CATEGORIES_MAXApi = 4;
export const PUBLIC_NAME_MAX_LENGTHApi = 30;
export const HOURLY_RATE_MINApi = 2;
export const HOURLY_RATE_MAXApi = 1000;
export const REHIRE_RANK_THRESHOLDSApi = [
    0,
    2,
    5,
    10,
    20,
];
export const IS_PUBLIC_NAME_RELEASEDApi = true;
export const GROUP_COVER_IMAGE_MIN_WIDTHApi = 588;
export const GROUP_COVER_IMAGE_MIN_HEIGHTApi = 115;
export const GROUP_COVER_IMAGE_DESCRIPTION_MAX_LENGTHApi = 256;
export const GROUP_COVER_IMAGE_MAX_DIMENSIONApi = 3840;
export const GROUP_COVER_IMAGE_FIXED_WIDTHApi = 3528;
export const GROUP_COVER_IMAGE_FIXED_HEIGHTApi = 690;
export const ORG_PERMISSION_ROLEApi = 'role';
export const ORG_PERMISSION_PROJECTSApi = 'projects';
export const ORG_PERMISSION_PAYMENTSApi = 'payments';
export var UserExceptionCodesApi;
(function (UserExceptionCodesApi) {
    UserExceptionCodesApi["NOT_FOUND"] = "not_found";
    UserExceptionCodesApi["DB_EXCEPTION"] = "db_exception";
    UserExceptionCodesApi["DAO_EXCEPTION"] = "dao_exception";
    UserExceptionCodesApi["IDENTITY_EXCEPTION"] = "identity_exception";
    UserExceptionCodesApi["GAF_EXCEPTION"] = "gaf_exception";
    UserExceptionCodesApi["INVALID_REQUEST"] = "invalid_request";
    UserExceptionCodesApi["UNKNOWN_ERROR"] = "unknown_error";
    UserExceptionCodesApi["USERNAME_TAKEN"] = "username_taken";
    UserExceptionCodesApi["EMAIL_TAKEN"] = "email_taken";
    UserExceptionCodesApi["INVALID_CAPTCHA"] = "invalid_captcha";
    UserExceptionCodesApi["CAPTCHA_REQUIRED"] = "captcha_required";
    UserExceptionCodesApi["SANCTIONED_NATION"] = "sanctioned_nation";
    UserExceptionCodesApi["FACEBOOK_EMAIL_TAKEN"] = "facebook_email_taken";
    UserExceptionCodesApi["FACEBOOK_EMAIL_EMPTY"] = "facebook_email_empty";
    UserExceptionCodesApi["FACEBOOK_SIGNUP_FAILED"] = "facebook_signup_failed";
    UserExceptionCodesApi["FACEBOOK_LINKING_FAILED"] = "facebook_linking_failed";
    UserExceptionCodesApi["INVALID_EMAIL"] = "invalid_email";
    UserExceptionCodesApi["INVALID_USERNAME"] = "invalid_username";
    UserExceptionCodesApi["EMAIL_BLOCKED"] = "email_blocked";
    UserExceptionCodesApi["INVALID_PASSWORD"] = "invalid_password";
    UserExceptionCodesApi["RESERVED_USERNAME"] = "reserved_username";
    UserExceptionCodesApi["INSUFFICIENT_JOB_CHANGES_LEFT"] = "insufficient_job_changes_left";
    UserExceptionCodesApi["EXCEEDS_MAX_ALLOWED_JOBS"] = "exceeds_max_allowed_jobs";
    UserExceptionCodesApi["INVALID_PROFILE_LANGUAGE"] = "invalid_profile_language";
    UserExceptionCodesApi["PROFILE_TAGLINE_TOO_LONG"] = "profile_tagline_too_long";
    UserExceptionCodesApi["PROFILE_DESCRIPTION_TOO_SHORT"] = "profile_description_too_short";
    UserExceptionCodesApi["PROFILE_DESCRIPTION_TOO_LONG"] = "profile_description_too_long";
    UserExceptionCodesApi["COVER_IMAGE_DESCRIPTION_TOO_LONG"] = "cover_image_description_too_long";
    UserExceptionCodesApi["COVER_IMAGE_UPLOAD_FAILED"] = "cover_image_upload_failed";
    UserExceptionCodesApi["INVALID_PHONE_NUMBER"] = "invalid_phone_number";
    UserExceptionCodesApi["PHONE_NUMBER_ALREADY_USED"] = "phone_number_already_used";
    UserExceptionCodesApi["PHONE_VERIFICATION_MAX_ATTEMPTS"] = "phone_verification_max_attempts";
    UserExceptionCodesApi["CANNOT_USE_PHONE_NUMBER"] = "cannot_use_phone_number";
    UserExceptionCodesApi["PHONE_NUMBER_SAME"] = "phone_number_same";
    UserExceptionCodesApi["INVALID_VERIFICATION"] = "invalid_verification";
    UserExceptionCodesApi["INVALID_VERIFICATION_CODE"] = "invalid_verification_code";
    UserExceptionCodesApi["PHONE_NUMBER_MISMATCH"] = "phone_number_mismatch";
    UserExceptionCodesApi["MUST_COMPLETE_ID_VERIFICATION"] = "must_complete_id_verification";
    UserExceptionCodesApi["SHOWCASE_INVALID_ID"] = "showcase_invalid_id";
    UserExceptionCodesApi["SHOWCASE_INVALID_USER_ID"] = "showcase_invalid_user_id";
    UserExceptionCodesApi["SHOWCASE_INVALID_SOURCE"] = "showcase_invalid_source";
    UserExceptionCodesApi["SHOWCASE_INVALID_SOURCE_ID"] = "showcase_invalid_source_id";
    UserExceptionCodesApi["SHOWCASE_INVALID_STATUS"] = "showcase_invalid_status";
    UserExceptionCodesApi["SHOWCASE_USER_HAS_NOT_LIKED"] = "showcase_user_has_not_liked";
    UserExceptionCodesApi["SHOWCASE_NOT_FOUND"] = "showcase_not_found";
    UserExceptionCodesApi["SHOWCASE_ITEM_NOT_FOUND"] = "showcase_item_not_found";
    UserExceptionCodesApi["EMAIL_ALREADY_VERIFIED"] = "email_already_verified";
    UserExceptionCodesApi["ACCOUNT_CLOSED_OR_SUSPENDED"] = "account_closed_or_suspended";
    UserExceptionCodesApi["ACCOUNT_LIMITED"] = "account_limited";
    UserExceptionCodesApi["FACEBOOK_USERNAME_TAKEN"] = "facebook_username_taken";
    UserExceptionCodesApi["INVALID_USER_ACCOUNT_SETTINGS"] = "invalid_user_account_settings";
    UserExceptionCodesApi["USER_NOT_FOUND"] = "user_not_found";
    UserExceptionCodesApi["USER_ID_REQUIRED"] = "user_id_required";
    UserExceptionCodesApi["INVITATION_LIMIT_EXCEEDED"] = "invitation_limit_exceeded";
    UserExceptionCodesApi["INVALID_NPS_SCORE"] = "invalid_nps_score";
    UserExceptionCodesApi["INVALID_LOCATION"] = "invalid_location";
    UserExceptionCodesApi["WEBHOOK_DUPLICATE"] = "webhook_duplicate";
    UserExceptionCodesApi["EMAIL_ALREADY_SUBSCRIBED"] = "email_already_subscribed";
    UserExceptionCodesApi["DISCOVER_COLLECTION_ITEM_DUPLICATE"] = "discover_collection_item_duplicate";
    UserExceptionCodesApi["DISCOVER_COLLECTION_NOT_FOUND"] = "discover_collection_not_found";
    UserExceptionCodesApi["DISCOVER_COLLECTION_DUPLICATE"] = "discover_collection_duplicate";
    UserExceptionCodesApi["DISCOVER_COLLECTION_USER_NOT_FOUND"] = "discover_collection_user_not_found";
    UserExceptionCodesApi["DISCOVER_COLLECTION_ITEM_NOT_FOUND"] = "discover_collection_item_not_found";
    UserExceptionCodesApi["AUTH_FORCE_RESET_PASSWORD"] = "auth_force_reset_password";
    UserExceptionCodesApi["AUTH_DEVICE_TOKEN_INVALID"] = "auth_device_token_invalid";
    UserExceptionCodesApi["AUTH_PRELOGIN_TOKEN_INVALID"] = "auth_prelogin_token_invalid";
    UserExceptionCodesApi["AUTH_PRELOGIN_TOKEN_EXPIRED"] = "auth_prelogin_token_expired";
    UserExceptionCodesApi["AUTH_TOTP_INVALID"] = "auth_totp_invalid";
    UserExceptionCodesApi["AUTH_TOKEN_MISMATCH"] = "auth_token_mismatch";
    UserExceptionCodesApi["AUTH_2FA_BLOCKED"] = "auth_2fa_blocked";
    UserExceptionCodesApi["APPLICATION_NAME_NOT_UNIQUE"] = "application_name_not_unique";
    UserExceptionCodesApi["NPS_COMMENT_TOO_LONG"] = "nps_comment_too_long";
    UserExceptionCodesApi["NPS_SOURCE_TYPE_INVALID"] = "nps_source_type_invalid";
    UserExceptionCodesApi["FACEBOOK_EMAIL_NOT_FOUND"] = "facebook_email_not_found";
    UserExceptionCodesApi["NPS_TYPE_INVALID"] = "nps_type_invalid";
    UserExceptionCodesApi["DISCOVER_COLLECTION_TYPE_INVALID"] = "discover_collection_type_invalid";
    UserExceptionCodesApi["INVITATION_TOKEN_INVALID"] = "invitation_token_invalid";
    UserExceptionCodesApi["INVITATION_INVALID"] = "invitation_invalid";
    UserExceptionCodesApi["INVITATION_LINK_CLOSED"] = "invitation_link_closed";
    UserExceptionCodesApi["USER_CUSTOM_EMAIL_LIMIT_REACHED"] = "user_custom_email_limit_reached";
    UserExceptionCodesApi["USER_CUSTOM_EMAIL_TEMPLATE_DATA_INVALID"] = "user_custom_email_template_data_invalid";
    UserExceptionCodesApi["USER_CUSTOM_EMAIL_RECIPIENT_INVALID"] = "user_custom_email_recipient_invalid";
    UserExceptionCodesApi["INVITATION_POOL_NOT_ALLOWED"] = "invitation_pool_not_allowed";
    UserExceptionCodesApi["APPLE_EMAIL_IS_NULL"] = "apple_email_is_null";
    UserExceptionCodesApi["UNAUTHORIZED_USER"] = "unauthorized_user";
    UserExceptionCodesApi["METADATA_FIELD_NOT_FOUND"] = "metadata_field_not_found";
    UserExceptionCodesApi["METADATA_FIELD_DISABLED"] = "metadata_field_disabled";
    UserExceptionCodesApi["METADATA_FIELD_VALUE_INVALID"] = "metadata_field_value_invalid";
    UserExceptionCodesApi["METADATA_FIELD_TYPE_INVALID"] = "metadata_field_type_invalid";
    UserExceptionCodesApi["METADATA_FIELD_VALUE_OBJECT_INVALID"] = "metadata_field_value_object_invalid";
    UserExceptionCodesApi["SEARCH_SAVED_FILTERS_DUPLICATE"] = "search_saved_filters_duplicate";
    UserExceptionCodesApi["SEARCH_SAVED_FILTERS_LIMIT_REACHED"] = "search_saved_filters_limit_reached";
    UserExceptionCodesApi["SEARCH_SAVED_FILTERS_NOT_FOUND"] = "search_saved_filters_not_found";
    UserExceptionCodesApi["USER_ACCOUNT_CLOSURE_RESTRICTED"] = "user_account_closure_restricted";
    UserExceptionCodesApi["USER_ACCOUNT_CLOSURE_NOT_ALLOWED"] = "user_account_closure_not_allowed";
    UserExceptionCodesApi["CONTRACT_NOT_FOUND"] = "contract_not_found";
    UserExceptionCodesApi["CONTRACT_ALREADY_SIGNED"] = "contract_already_signed";
    UserExceptionCodesApi["CONTRACT_VERIFICATION_FAILED"] = "contract_verification_failed";
    UserExceptionCodesApi["CONTRACT_CONTEXT_NOT_FOUND"] = "contract_context_not_found";
    UserExceptionCodesApi["CONTRACT_INVALID_DOWNLOAD"] = "contract_invalid_download";
    UserExceptionCodesApi["CONTRACT_TEMPLATE_NOT_FOUND"] = "contract_template_not_found";
    UserExceptionCodesApi["CONTRACT_SIGNEE_ROLE_NOT_FOUND"] = "contract_signee_role_not_found";
    UserExceptionCodesApi["TAX_NUMBER_INVALID"] = "tax_number_invalid";
    UserExceptionCodesApi["TAX_TYPE_NOT_SUPPORTED"] = "tax_type_not_supported";
    UserExceptionCodesApi["TAX_NUMBER_DUPLICATE"] = "tax_number_duplicate";
    UserExceptionCodesApi["TAX_SUBTYPE_INVALID"] = "tax_subtype_invalid";
    UserExceptionCodesApi["TAX_DEACTIVATE_NOT_ALLOWED"] = "tax_deactivate_not_allowed";
    UserExceptionCodesApi["TAX_NUMBER_DOES_NOT_EXIST"] = "tax_number_does_not_exist";
    UserExceptionCodesApi["US_TAX_MATCH_REJECTED"] = "us_tax_match_rejected";
    UserExceptionCodesApi["US_TAX_MATCH_COMMUNICATION_ERROR"] = "us_tax_match_communication_error";
    UserExceptionCodesApi["TAX_OPT_OUT_NOT_ALLOWED"] = "tax_opt_out_not_allowed";
    UserExceptionCodesApi["TAX_OPT_OUT_INVALID_OPTION"] = "tax_opt_out_invalid_option";
    UserExceptionCodesApi["TAX_OPT_OUT_EXTRA_DETAILS_REQUIRED"] = "tax_opt_out_extra_details_required";
    UserExceptionCodesApi["TAX_OPT_OUT_NOT_FOUND"] = "tax_opt_out_not_found";
    UserExceptionCodesApi["TAX_OPT_OUT_DUPLICATE"] = "tax_opt_out_duplicate";
    UserExceptionCodesApi["TAX_OPT_OUT_REVERT_NOT_ALLOWED"] = "tax_opt_out_revert_not_allowed";
    UserExceptionCodesApi["CONTENT_CUSTOMIZATION_INVALID"] = "content_customization_invalid";
    UserExceptionCodesApi["CONTENT_CUSTOMIZATION_FILE_NOT_FOUND"] = "content_customization_file_not_found";
    UserExceptionCodesApi["CONTENT_CUSTOMIZATION_FILE_EXCEEDS_LIMIT"] = "content_customization_file_exceeds_limit";
    UserExceptionCodesApi["CONTENT_CUSTOMIZATION_ALREADY_EXISTS"] = "content_customization_already_exists";
    UserExceptionCodesApi["CONTENT_CUSTOMIZATION_NOT_FOUND"] = "content_customization_not_found";
    UserExceptionCodesApi["CURRENCY_NOT_FOUND"] = "currency_not_found";
    UserExceptionCodesApi["USER_NOT_IN_PFP"] = "user_not_in_pfp";
    UserExceptionCodesApi["PFP_SKILL_NOT_FOUND"] = "pfp_skill_not_found";
    UserExceptionCodesApi["PFP_SKILL_INVALID"] = "pfp_skill_invalid";
    UserExceptionCodesApi["PFP_SKILL_DUPLICATE"] = "pfp_skill_duplicate";
    UserExceptionCodesApi["OPERATING_AREA_NOT_FOUND"] = "operating_area_not_found";
    UserExceptionCodesApi["USER_DOCUMENT_SUBMISSION_DUPLICATE"] = "user_document_submission_duplicate";
    UserExceptionCodesApi["USER_DOCUMENT_SUBMISSION_NOT_FOUND"] = "user_document_submission_not_found";
    UserExceptionCodesApi["DOCUMENT_TYPE_NOT_FOUND"] = "document_type_not_found";
    UserExceptionCodesApi["DOCUMENT_TYPE_FILE_NOT_FOUND"] = "document_type_file_not_found";
    UserExceptionCodesApi["DOCUMENT_TYPE_FIELD_NOT_FOUND"] = "document_type_field_not_found";
    UserExceptionCodesApi["VERIFICATION_PROCESS_TYPE_NOT_FOUND"] = "verification_process_type_not_found";
    UserExceptionCodesApi["USER_VERIFICATION_PROCESS_NOT_FOUND"] = "user_verification_process_not_found";
    UserExceptionCodesApi["USER_VERIFICATION_PROCESS_ALREADY_ACTIVE"] = "user_verification_process_already_active";
    UserExceptionCodesApi["USER_DOCUMENT_SUBMISSION_ALREADY_ACTIVE"] = "user_document_submission_already_active";
    UserExceptionCodesApi["USER_AVAILABILITY_NOT_FOUND"] = "user_availability_not_found";
    UserExceptionCodesApi["USER_AVAILABILITY_INVALID_DATE_RANGE"] = "user_availability_invalid_date_range";
    UserExceptionCodesApi["PAYMENT_SHARING_INVALID_DATE_TIME_RANGE"] = "payment_sharing_invalid_date_time_range";
})(UserExceptionCodesApi || (UserExceptionCodesApi = {}));
export var UserFollowStatusApi;
(function (UserFollowStatusApi) {
    UserFollowStatusApi["UNFOLLOWED"] = "unfollowed";
    UserFollowStatusApi["FOLLOWING"] = "following";
})(UserFollowStatusApi || (UserFollowStatusApi = {}));
export var TokenKindApi;
(function (TokenKindApi) {
    TokenKindApi["IOS"] = "ios";
    TokenKindApi["ANDROID"] = "android";
    TokenKindApi["FCM"] = "fcm";
})(TokenKindApi || (TokenKindApi = {}));
export var ContentTypeApi;
(function (ContentTypeApi) {
    ContentTypeApi["PICTURE"] = "picture";
    ContentTypeApi["VIDEO"] = "video";
    ContentTypeApi["AUDIO"] = "audio";
    ContentTypeApi["OTHER"] = "other";
    ContentTypeApi["ARTICLE"] = "article";
    ContentTypeApi["CODE"] = "code";
})(ContentTypeApi || (ContentTypeApi = {}));
export var AppTypeApi;
(function (AppTypeApi) {
    AppTypeApi["FREELANCER"] = "freelancer";
    AppTypeApi["LOCAL_JOBS"] = "local_jobs";
})(AppTypeApi || (AppTypeApi = {}));
export var UserChosenRoleApi;
(function (UserChosenRoleApi) {
    UserChosenRoleApi["FREELANCER"] = "freelancer";
    UserChosenRoleApi["EMPLOYER"] = "employer";
    UserChosenRoleApi["BOTH"] = "both";
})(UserChosenRoleApi || (UserChosenRoleApi = {}));
export var UserSupportTypeApi;
(function (UserSupportTypeApi) {
    UserSupportTypeApi["TECHNICAL"] = "technical";
    UserSupportTypeApi["ASSISTED"] = "assisted";
    UserSupportTypeApi["GENERAL"] = "general";
    UserSupportTypeApi["LOCAL"] = "local";
    UserSupportTypeApi["PAYMENT_SATISFACTION"] = "payment_satisfaction";
    UserSupportTypeApi["MEMBERSHIP_CURATION"] = "membership_curation";
    UserSupportTypeApi["PROJECT_MANAGEMENT"] = "project_management";
    UserSupportTypeApi["SUCCESS_MANAGER"] = "success_manager";
    UserSupportTypeApi["ARROW_CONCIERGE"] = "arrow_concierge";
    UserSupportTypeApi["FREIGHTLANCER_CONCIERGE"] = "freightlancer_concierge";
    UserSupportTypeApi["DELOITTE_COMPLIANCE_QUEUE"] = "deloitte_compliance_queue";
    UserSupportTypeApi["ENTERPRISE_CONCIERGE_QUEUE"] = "enterprise_concierge_queue";
    UserSupportTypeApi["FREIGHTLANCER_ASSIGNED_SALES_QUEUE"] = "freightlancer_assigned_sales_queue";
    UserSupportTypeApi["LOADSHIFT_MARKETPLACE_QUEUE"] = "loadshift_marketplace_queue";
    UserSupportTypeApi["VERIFIED_SALES"] = "verified_sales";
    UserSupportTypeApi["AI_FLOWS"] = "ai_flows";
    UserSupportTypeApi["AI_ESCALATIONS"] = "ai_escalations";
})(UserSupportTypeApi || (UserSupportTypeApi = {}));
export var ShowcaseItemStatusApi;
(function (ShowcaseItemStatusApi) {
    ShowcaseItemStatusApi["PENDING"] = "pending";
    ShowcaseItemStatusApi["CURATED"] = "curated";
    ShowcaseItemStatusApi["APPROVED"] = "approved";
    ShowcaseItemStatusApi["REJECTED"] = "rejected";
    ShowcaseItemStatusApi["EXPIRED"] = "expired";
    ShowcaseItemStatusApi["DELETED"] = "deleted";
    ShowcaseItemStatusApi["HIDDEN"] = "hidden";
})(ShowcaseItemStatusApi || (ShowcaseItemStatusApi = {}));
export var UserCompletedWorkContextApi;
(function (UserCompletedWorkContextApi) {
    UserCompletedWorkContextApi["PROJECT"] = "project";
    UserCompletedWorkContextApi["CONTEST"] = "contest";
    UserCompletedWorkContextApi["SHOWCASE"] = "showcase";
})(UserCompletedWorkContextApi || (UserCompletedWorkContextApi = {}));
export var UserDetailChangeRequestTypeApi;
(function (UserDetailChangeRequestTypeApi) {
    UserDetailChangeRequestTypeApi["FIRST_NAME"] = "first_name";
    UserDetailChangeRequestTypeApi["LAST_NAME"] = "last_name";
    UserDetailChangeRequestTypeApi["ADDRESS"] = "address";
    UserDetailChangeRequestTypeApi["ADDRESS_2"] = "address_2";
    UserDetailChangeRequestTypeApi["CITY"] = "city";
    UserDetailChangeRequestTypeApi["ZIP"] = "zip";
    UserDetailChangeRequestTypeApi["STATE"] = "state";
    UserDetailChangeRequestTypeApi["COUNTRY"] = "country";
    UserDetailChangeRequestTypeApi["LOCATION"] = "location";
    UserDetailChangeRequestTypeApi["EMAIL"] = "email";
    UserDetailChangeRequestTypeApi["PROFILE_PHOTO"] = "profile_photo";
    UserDetailChangeRequestTypeApi["COMPANY"] = "company";
    UserDetailChangeRequestTypeApi["TIME_ZONE"] = "time_zone";
    UserDetailChangeRequestTypeApi["PHONE_NUMBER"] = "phone_number";
    UserDetailChangeRequestTypeApi["FACEBOOK"] = "facebook";
    UserDetailChangeRequestTypeApi["LINKED_IN"] = "linked_in";
})(UserDetailChangeRequestTypeApi || (UserDetailChangeRequestTypeApi = {}));
export var UserDetailChangeRequestStatusApi;
(function (UserDetailChangeRequestStatusApi) {
    UserDetailChangeRequestStatusApi["PENDING"] = "pending";
    UserDetailChangeRequestStatusApi["ACCEPTED"] = "accepted";
    UserDetailChangeRequestStatusApi["REJECTED"] = "rejected";
    UserDetailChangeRequestStatusApi["CANCELLED"] = "cancelled";
    UserDetailChangeRequestStatusApi["INVALID"] = "invalid";
})(UserDetailChangeRequestStatusApi || (UserDetailChangeRequestStatusApi = {}));
export var FreelancerVerifiedUserStatusApi;
(function (FreelancerVerifiedUserStatusApi) {
    FreelancerVerifiedUserStatusApi["PENDING"] = "pending";
    FreelancerVerifiedUserStatusApi["ACCEPTED"] = "accepted";
    FreelancerVerifiedUserStatusApi["REJECTED"] = "rejected";
    FreelancerVerifiedUserStatusApi["REMOVED"] = "removed";
    FreelancerVerifiedUserStatusApi["REVIEW"] = "review";
})(FreelancerVerifiedUserStatusApi || (FreelancerVerifiedUserStatusApi = {}));
export var ArticleStateApi;
(function (ArticleStateApi) {
    ArticleStateApi["PENDING"] = "pending";
    ArticleStateApi["APPROVED"] = "approved";
    ArticleStateApi["REJECTED"] = "rejected";
    ArticleStateApi["CLOSED"] = "closed";
    ArticleStateApi["DRAFT"] = "draft";
})(ArticleStateApi || (ArticleStateApi = {}));
export var ArticleTypeApi;
(function (ArticleTypeApi) {
    ArticleTypeApi["BLOG"] = "blog";
    ArticleTypeApi["ARTICLE"] = "article";
    ArticleTypeApi["QUESTION"] = "question";
    ArticleTypeApi["NEWS"] = "news";
    ArticleTypeApi["HELP_CENTER"] = "help_center";
    ArticleTypeApi["CONTENT_HUB"] = "content_hub";
    ArticleTypeApi["MASTER_ARTICLE"] = "master_article";
})(ArticleTypeApi || (ArticleTypeApi = {}));
export var ShowcaseStatusApi;
(function (ShowcaseStatusApi) {
    ShowcaseStatusApi["ACTIVE"] = "active";
    ShowcaseStatusApi["HIDDEN"] = "hidden";
    ShowcaseStatusApi["DELETED"] = "deleted";
})(ShowcaseStatusApi || (ShowcaseStatusApi = {}));
export var ShowcaseSourceTypeApi;
(function (ShowcaseSourceTypeApi) {
    ShowcaseSourceTypeApi["PROJECT"] = "project";
    ShowcaseSourceTypeApi["CONTEST"] = "contest";
    ShowcaseSourceTypeApi["EXTERNAL"] = "external";
    ShowcaseSourceTypeApi["PORTFOLIO"] = "portfolio";
})(ShowcaseSourceTypeApi || (ShowcaseSourceTypeApi = {}));
export var ShowcaseSortFieldApi;
(function (ShowcaseSortFieldApi) {
    ShowcaseSortFieldApi["LIKES"] = "likes";
    ShowcaseSortFieldApi["QUALITY_SCORE"] = "quality_score";
    ShowcaseSortFieldApi["TIME_SUBMITTED"] = "time_submitted";
    ShowcaseSortFieldApi["HIREME_COUNT"] = "hireme_count";
})(ShowcaseSortFieldApi || (ShowcaseSortFieldApi = {}));
export var ShowcaseSortDirApi;
(function (ShowcaseSortDirApi) {
    ShowcaseSortDirApi["DESC"] = "desc";
    ShowcaseSortDirApi["ASC"] = "asc";
})(ShowcaseSortDirApi || (ShowcaseSortDirApi = {}));
export var ReputationPeriodApi;
(function (ReputationPeriodApi) {
    ReputationPeriodApi["ENTIRE_HISTORY"] = "entire_history";
    ReputationPeriodApi["LAST_3_MONTHS"] = "last_3_months";
    ReputationPeriodApi["LAST_12_MONTHS"] = "last_12_months";
})(ReputationPeriodApi || (ReputationPeriodApi = {}));
export var PhoneVerificationRequestTypeApi;
(function (PhoneVerificationRequestTypeApi) {
    PhoneVerificationRequestTypeApi["SMS"] = "sms";
    PhoneVerificationRequestTypeApi["CALL"] = "call";
})(PhoneVerificationRequestTypeApi || (PhoneVerificationRequestTypeApi = {}));
export var CorporateStatusApi;
(function (CorporateStatusApi) {
    CorporateStatusApi["ACTIVE"] = "active";
    CorporateStatusApi["EXPIRED"] = "expired";
    CorporateStatusApi["PENDING"] = "pending";
})(CorporateStatusApi || (CorporateStatusApi = {}));
export var TeamRoleApi;
(function (TeamRoleApi) {
    TeamRoleApi["MEMBER"] = "member";
    TeamRoleApi["ADMIN"] = "admin";
    TeamRoleApi["OWNER"] = "owner";
})(TeamRoleApi || (TeamRoleApi = {}));
export var OnlineOfflineStatusApi;
(function (OnlineOfflineStatusApi) {
    OnlineOfflineStatusApi["OFFLINE"] = "offline";
    OnlineOfflineStatusApi["ONLINE"] = "online";
})(OnlineOfflineStatusApi || (OnlineOfflineStatusApi = {}));
export var DiscoverCollectionTypeApi;
(function (DiscoverCollectionTypeApi) {
    DiscoverCollectionTypeApi["FAVORITES"] = "favorites";
    DiscoverCollectionTypeApi["CUSTOM"] = "custom";
    DiscoverCollectionTypeApi["LISTS_FAVORITES"] = "lists_favorites";
    DiscoverCollectionTypeApi["LISTS_MY_HIRES"] = "lists_my_hires";
    DiscoverCollectionTypeApi["LISTS_CUSTOM"] = "lists_custom";
    DiscoverCollectionTypeApi["LISTS_MY_CLIENTS"] = "lists_my_clients";
    DiscoverCollectionTypeApi["LISTS_RECENTLY_VIEWED_USERS"] = "lists_recently_viewed_users";
    DiscoverCollectionTypeApi["LISTS_GROUP_FEED_ITEMS"] = "lists_group_feed_items";
})(DiscoverCollectionTypeApi || (DiscoverCollectionTypeApi = {}));
export var DiscoverCollectionDefaultFieldApi;
(function (DiscoverCollectionDefaultFieldApi) {
    DiscoverCollectionDefaultFieldApi["NAME"] = "name";
    DiscoverCollectionDefaultFieldApi["DESCRIPTION"] = "description";
    DiscoverCollectionDefaultFieldApi["URL"] = "url";
})(DiscoverCollectionDefaultFieldApi || (DiscoverCollectionDefaultFieldApi = {}));
export var OperatingAreaTypeApi;
(function (OperatingAreaTypeApi) {
    OperatingAreaTypeApi["STREET"] = "street";
    OperatingAreaTypeApi["POSTCODE"] = "postcode";
    OperatingAreaTypeApi["CITY"] = "city";
    OperatingAreaTypeApi["STATE"] = "state";
    OperatingAreaTypeApi["COUNTRY"] = "country";
    OperatingAreaTypeApi["REGION"] = "region";
})(OperatingAreaTypeApi || (OperatingAreaTypeApi = {}));
export const DISCOVER_COLLECTION_DEFAULTApi = {
    [DiscoverCollectionTypeApi.LISTS_FAVORITES]: {
        [DiscoverCollectionDefaultFieldApi.NAME]: 'Favorites',
        [DiscoverCollectionDefaultFieldApi.DESCRIPTION]: '',
        [DiscoverCollectionDefaultFieldApi.URL]: 'favorites',
    },
    [DiscoverCollectionTypeApi.LISTS_MY_HIRES]: {
        [DiscoverCollectionDefaultFieldApi.NAME]: 'My Hires',
        [DiscoverCollectionDefaultFieldApi.DESCRIPTION]: "Here you can find all freelancers who you've worked with in the past.",
        [DiscoverCollectionDefaultFieldApi.URL]: 'my-hires',
    },
    [DiscoverCollectionTypeApi.LISTS_MY_CLIENTS]: {
        [DiscoverCollectionDefaultFieldApi.NAME]: 'My Clients',
        [DiscoverCollectionDefaultFieldApi.DESCRIPTION]: "Here you can find all employers who you've worked with in the past.",
        [DiscoverCollectionDefaultFieldApi.URL]: 'my-clients',
    },
    [DiscoverCollectionTypeApi.LISTS_RECENTLY_VIEWED_USERS]: {
        [DiscoverCollectionDefaultFieldApi.NAME]: 'Recently Viewed Users',
        [DiscoverCollectionDefaultFieldApi.DESCRIPTION]: 'Here you can find users whose profiles you have recently viewed.',
        [DiscoverCollectionDefaultFieldApi.URL]: 'recently-viewed-users',
    },
    [DiscoverCollectionTypeApi.LISTS_GROUP_FEED_ITEMS]: {
        [DiscoverCollectionDefaultFieldApi.NAME]: 'Bookmarked Group Posts',
        [DiscoverCollectionDefaultFieldApi.DESCRIPTION]: 'Here you can find all group posts that you have bookmarked.',
        [DiscoverCollectionDefaultFieldApi.URL]: 'bookmarked-group-posts',
    },
};
export var DiscoverCollectionItemTypeApi;
(function (DiscoverCollectionItemTypeApi) {
    DiscoverCollectionItemTypeApi["PORTFOLIO"] = "portfolio";
    DiscoverCollectionItemTypeApi["PORTFOLIO_ITEM"] = "portfolio_item";
    DiscoverCollectionItemTypeApi["USER"] = "user";
    DiscoverCollectionItemTypeApi["FEED_ITEM"] = "feed_item";
})(DiscoverCollectionItemTypeApi || (DiscoverCollectionItemTypeApi = {}));
export var MarketingMobileNumberStatusApi;
(function (MarketingMobileNumberStatusApi) {
    MarketingMobileNumberStatusApi["INVALID"] = "invalid";
    MarketingMobileNumberStatusApi["VALID"] = "valid";
})(MarketingMobileNumberStatusApi || (MarketingMobileNumberStatusApi = {}));
export var AccountTypeApi;
(function (AccountTypeApi) {
    AccountTypeApi["COMPANY"] = "company";
    AccountTypeApi["INDIVIDUAL"] = "individual";
})(AccountTypeApi || (AccountTypeApi = {}));
export var UserSanctionPenaltyTypeApi;
(function (UserSanctionPenaltyTypeApi) {
    UserSanctionPenaltyTypeApi["BID_RESTRICTION"] = "bid_restriction";
})(UserSanctionPenaltyTypeApi || (UserSanctionPenaltyTypeApi = {}));
export var UserSanctionReasonTypeApi;
(function (UserSanctionReasonTypeApi) {
    UserSanctionReasonTypeApi["BID_SPAM"] = "bid_spam";
})(UserSanctionReasonTypeApi || (UserSanctionReasonTypeApi = {}));
export var ViolationReportContextTypeApi;
(function (ViolationReportContextTypeApi) {
    ViolationReportContextTypeApi["PROJECT"] = "project";
    ViolationReportContextTypeApi["BID"] = "bid";
    ViolationReportContextTypeApi["MESSAGE"] = "message";
    ViolationReportContextTypeApi["PROFILE"] = "profile";
    ViolationReportContextTypeApi["MARKETPLACE_COMMENT"] = "marketplace_comment";
    ViolationReportContextTypeApi["PRIVATE_MESSAGE"] = "private_message";
    ViolationReportContextTypeApi["CONTEST_ENTRY"] = "contest_entry";
    ViolationReportContextTypeApi["CONTEST_COMMENT"] = "contest_comment";
    ViolationReportContextTypeApi["COPYRIGHT_INFRINGEMENT"] = "copyright_infringement";
    ViolationReportContextTypeApi["POST"] = "post";
    ViolationReportContextTypeApi["COMMENT"] = "comment";
    ViolationReportContextTypeApi["PROJECT_QUESTION"] = "project_question";
    ViolationReportContextTypeApi["INVITATION"] = "invitation";
    ViolationReportContextTypeApi["THREAD"] = "thread";
})(ViolationReportContextTypeApi || (ViolationReportContextTypeApi = {}));
export var ViolationReportReasonApi;
(function (ViolationReportReasonApi) {
    ViolationReportReasonApi["CONTACTS"] = "contacts";
    ViolationReportReasonApi["ADVERTISING"] = "advertising";
    ViolationReportReasonApi["FAKE"] = "fake";
    ViolationReportReasonApi["HARASSMENT"] = "harassment";
    ViolationReportReasonApi["NONFEATURED"] = "nonfeatured";
    ViolationReportReasonApi["OTHER"] = "other";
})(ViolationReportReasonApi || (ViolationReportReasonApi = {}));
export var ViolationReportAdditionalReasonApi;
(function (ViolationReportAdditionalReasonApi) {
    ViolationReportAdditionalReasonApi["OFFSITING_PAYMENT"] = "offsiting_payment";
    ViolationReportAdditionalReasonApi["OFFSITING_COMMUNICATION"] = "offsiting_communication";
    ViolationReportAdditionalReasonApi["PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS"] = "public_display_of_communication_details";
    ViolationReportAdditionalReasonApi["FAKE_PROFILE"] = "fake_profile";
    ViolationReportAdditionalReasonApi["MISLEADING_ABOUT_OWN_ABILITIES"] = "misleading_about_own_abilities";
    ViolationReportAdditionalReasonApi["MISLEADING_CONTENT_ON_PROFILE"] = "misleading_content_on_profile";
    ViolationReportAdditionalReasonApi["USER_IS_AN_ORGANIZATION_NOT_A_PERSON"] = "user_is_an_organization_not_a_person";
    ViolationReportAdditionalReasonApi["SENDING_THREATS_OF_VIOLENCE"] = "sending_threats_of_violence";
    ViolationReportAdditionalReasonApi["INAPPROPRIATE_LANGUAGE"] = "inappropriate_language";
    ViolationReportAdditionalReasonApi["ISSUE_ON_PROJECT_WITH_USER"] = "issue_on_project_with_user";
    ViolationReportAdditionalReasonApi["ISSUE_ON_PROJECT_WITH_SOMEONE_ELSE"] = "issue_on_project_with_someone_else";
    ViolationReportAdditionalReasonApi["OTHER"] = "other";
    ViolationReportAdditionalReasonApi["COPIED_WORK_FROM_USER"] = "copied_work_from_user";
    ViolationReportAdditionalReasonApi["COPIED_WORK_FROM_SOMEONE_ELSE"] = "copied_work_from_someone_else";
    ViolationReportAdditionalReasonApi["EXPLICIT_OR_INAPPROPRIATE_CONTENT"] = "explicit_or_inappropriate_content";
    ViolationReportAdditionalReasonApi["LOW_QUALITY_WORK"] = "low_quality_work";
    ViolationReportAdditionalReasonApi["WORK_DOES_NOT_MATCH_REQUIREMENTS"] = "work_does_not_match_requirements";
    ViolationReportAdditionalReasonApi["INVITATION_SPAM"] = "invitation_spam";
    ViolationReportAdditionalReasonApi["IRRELEVANT_INFORMATION"] = "irrelevant_information";
    ViolationReportAdditionalReasonApi["NOT_MAKING_SENSE"] = "not_making_sense";
    ViolationReportAdditionalReasonApi["EXCESSIVE_SELF_PROMOTION"] = "excessive_self_promotion";
    ViolationReportAdditionalReasonApi["PROJECT_UNAVAILABLE"] = "project_unavailable";
    ViolationReportAdditionalReasonApi["INACCURATE_PROJECT_DETAILS"] = "inaccurate_project_details";
    ViolationReportAdditionalReasonApi["UNRESPONSIVE_USER"] = "unresponsive_user";
    ViolationReportAdditionalReasonApi["USER_NEEDS_ASSISTANCE"] = "user_needs_assistance";
    ViolationReportAdditionalReasonApi["USER_AVAILABILITY_POSTED_AS_PROJECT"] = "user_availability_posted_as_project";
    ViolationReportAdditionalReasonApi["CHAIN_OF_RESPONSIBILITY_CONCERN"] = "chain_of_responsibility_concern";
})(ViolationReportAdditionalReasonApi || (ViolationReportAdditionalReasonApi = {}));
export var NetPromoterScoreTypeApi;
(function (NetPromoterScoreTypeApi) {
    NetPromoterScoreTypeApi["FREELANCER"] = "freelancer";
    NetPromoterScoreTypeApi["EMPLOYER"] = "employer";
    NetPromoterScoreTypeApi["CONTEST_PLATFORM"] = "contest_platform";
    NetPromoterScoreTypeApi["SUPPORT_PLATFORM"] = "support_platform";
    NetPromoterScoreTypeApi["SUPPORT_QUEUE"] = "support_queue";
    NetPromoterScoreTypeApi["SITEWIDE_EXPERIENCE"] = "sitewide_experience";
    NetPromoterScoreTypeApi["VERIFICATION_EXPERIENCE"] = "verification_experience";
})(NetPromoterScoreTypeApi || (NetPromoterScoreTypeApi = {}));
export var NetPromoterScoreSourceApi;
(function (NetPromoterScoreSourceApi) {
    NetPromoterScoreSourceApi["MILESTONE"] = "milestone";
    NetPromoterScoreSourceApi["PROJECT_COMPLETE"] = "project_complete";
    NetPromoterScoreSourceApi["INVOICE"] = "invoice";
    NetPromoterScoreSourceApi["CONTEST_ONGOING"] = "contest_ongoing";
    NetPromoterScoreSourceApi["HELPCENTER_EXPERIENCE"] = "helpcenter_experience";
    NetPromoterScoreSourceApi["CONTEST_HANDOVER"] = "contest_handover";
    NetPromoterScoreSourceApi["RICH_MESSAGE_ON_RESOLVE"] = "rich_message_on_resolve";
    NetPromoterScoreSourceApi["RICH_MESSAGE_ON_24HR"] = "rich_message_on_24hr";
    NetPromoterScoreSourceApi["SITEWIDE_EXPERIENCE_PENDING"] = "sitewide_experience_pending";
    NetPromoterScoreSourceApi["SITEWIDE_EXPERIENCE_COMPLETE"] = "sitewide_experience_complete";
    NetPromoterScoreSourceApi["KYC_COMPLETE"] = "kyc_complete";
})(NetPromoterScoreSourceApi || (NetPromoterScoreSourceApi = {}));
export var UserOnboardingCompletionTypeApi;
(function (UserOnboardingCompletionTypeApi) {
    UserOnboardingCompletionTypeApi["COMPLETED"] = "completed";
    UserOnboardingCompletionTypeApi["SKIPPED"] = "skipped";
})(UserOnboardingCompletionTypeApi || (UserOnboardingCompletionTypeApi = {}));
export var PaymentShareEntityTypeApi;
(function (PaymentShareEntityTypeApi) {
    PaymentShareEntityTypeApi["USER"] = "user";
})(PaymentShareEntityTypeApi || (PaymentShareEntityTypeApi = {}));
export var PaymentShareTeamStatusApi;
(function (PaymentShareTeamStatusApi) {
    PaymentShareTeamStatusApi["DISABLED"] = "disabled";
    PaymentShareTeamStatusApi["ENABLED"] = "enabled";
})(PaymentShareTeamStatusApi || (PaymentShareTeamStatusApi = {}));
export var PaymentShareSpendingLimitDurationApi;
(function (PaymentShareSpendingLimitDurationApi) {
    PaymentShareSpendingLimitDurationApi["NO_TIME_LIMIT"] = "no_time_limit";
    PaymentShareSpendingLimitDurationApi["PER_MONTH"] = "per_month";
})(PaymentShareSpendingLimitDurationApi || (PaymentShareSpendingLimitDurationApi = {}));
export var PaymentShareMemberRoleApi;
(function (PaymentShareMemberRoleApi) {
    PaymentShareMemberRoleApi["OWNER"] = "owner";
    PaymentShareMemberRoleApi["MEMBER"] = "member";
})(PaymentShareMemberRoleApi || (PaymentShareMemberRoleApi = {}));
export var PaymentShareMemberStatusApi;
(function (PaymentShareMemberStatusApi) {
    PaymentShareMemberStatusApi["REMOVED"] = "removed";
    PaymentShareMemberStatusApi["ADDED"] = "added";
})(PaymentShareMemberStatusApi || (PaymentShareMemberStatusApi = {}));
export var PaymentShareSpendAmountTimeIntervalApi;
(function (PaymentShareSpendAmountTimeIntervalApi) {
    PaymentShareSpendAmountTimeIntervalApi["DAY"] = "day";
    PaymentShareSpendAmountTimeIntervalApi["WEEK"] = "week";
    PaymentShareSpendAmountTimeIntervalApi["MONTH"] = "month";
})(PaymentShareSpendAmountTimeIntervalApi || (PaymentShareSpendAmountTimeIntervalApi = {}));
export var PaymentShareTeamNominationContextApi;
(function (PaymentShareTeamNominationContextApi) {
    PaymentShareTeamNominationContextApi["ENTERPRISE"] = "enterprise";
})(PaymentShareTeamNominationContextApi || (PaymentShareTeamNominationContextApi = {}));
export var PaymentShareTeamNominationStatusApi;
(function (PaymentShareTeamNominationStatusApi) {
    PaymentShareTeamNominationStatusApi["INACTIVE"] = "inactive";
    PaymentShareTeamNominationStatusApi["ACTIVE"] = "active";
})(PaymentShareTeamNominationStatusApi || (PaymentShareTeamNominationStatusApi = {}));
export var AccountClosureReasonApi;
(function (AccountClosureReasonApi) {
    AccountClosureReasonApi["PRIVACY_CONCERNS"] = "privacy_concerns";
    AccountClosureReasonApi["UNHELPFUL"] = "unhelpful";
    AccountClosureReasonApi["TOO_MANY_NOTIFICATIONS"] = "too_many_notifications";
    AccountClosureReasonApi["CAN_NOT_UNDERSTAND"] = "can_not_understand";
    AccountClosureReasonApi["TEMPORARY"] = "temporary";
    AccountClosureReasonApi["OTHER"] = "other";
    AccountClosureReasonApi["SPAM"] = "spam";
    AccountClosureReasonApi["ENTERPRISE_USER_MANAGEMENT"] = "enterprise_user_management";
    AccountClosureReasonApi["USER_REQUEST"] = "user_request";
    AccountClosureReasonApi["USER_REQUEST_DUPLICATE"] = "user_request_duplicate";
    AccountClosureReasonApi["FRAUD"] = "fraud";
    AccountClosureReasonApi["HACKING_INCIDENT"] = "hacking_incident";
    AccountClosureReasonApi["OFFSITING"] = "offsiting";
    AccountClosureReasonApi["RESTRICTED_COUNTRY"] = "restricted_country";
    AccountClosureReasonApi["SCAM"] = "scam";
    AccountClosureReasonApi["DUPLICATE_ACCOUNT_VT"] = "duplicate_account_vt";
    AccountClosureReasonApi["NON_COMPLIANCE_VERIFICATION"] = "non_compliance_verification";
    AccountClosureReasonApi["MEMBERSHIP_TRIAL_AUTORENEWAL"] = "membership_trial_autorenewal";
    AccountClosureReasonApi["STAFF_OFFBOARDING"] = "staff_offboarding";
    AccountClosureReasonApi["ENTERPRISE_USER_OFFBOARDING"] = "enterprise_user_offboarding";
})(AccountClosureReasonApi || (AccountClosureReasonApi = {}));
export var AccountClosureTypeApi;
(function (AccountClosureTypeApi) {
    AccountClosureTypeApi["ADMIN"] = "admin";
    AccountClosureTypeApi["USER"] = "user";
    AccountClosureTypeApi["ENTERPRISE_SUPERUSER"] = "enterprise_superuser";
})(AccountClosureTypeApi || (AccountClosureTypeApi = {}));
export var SearchFiltersProjectSortingOptionApi;
(function (SearchFiltersProjectSortingOptionApi) {
    SearchFiltersProjectSortingOptionApi["LATEST"] = "latest";
    SearchFiltersProjectSortingOptionApi["OLDEST"] = "oldest";
    SearchFiltersProjectSortingOptionApi["LOWEST_PRICE"] = "lowest_price";
    SearchFiltersProjectSortingOptionApi["HIGHEST_PRICE"] = "highest_price";
    SearchFiltersProjectSortingOptionApi["FEWEST_BIDS"] = "fewest_bids";
    SearchFiltersProjectSortingOptionApi["MOST_BIDS"] = "most_bids";
})(SearchFiltersProjectSortingOptionApi || (SearchFiltersProjectSortingOptionApi = {}));
export var SearchFiltersContestSortingOptionApi;
(function (SearchFiltersContestSortingOptionApi) {
    SearchFiltersContestSortingOptionApi["LATEST"] = "latest";
    SearchFiltersContestSortingOptionApi["OLDEST"] = "oldest";
    SearchFiltersContestSortingOptionApi["LOWEST_PRIZE"] = "lowest_prize";
    SearchFiltersContestSortingOptionApi["HIGHEST_PRIZE"] = "highest_prize";
    SearchFiltersContestSortingOptionApi["FEWEST_ENTRIES"] = "fewest_entries";
    SearchFiltersContestSortingOptionApi["MOST_ENTRIES"] = "most_entries";
})(SearchFiltersContestSortingOptionApi || (SearchFiltersContestSortingOptionApi = {}));
export var SearchFiltersProjectTypeApi;
(function (SearchFiltersProjectTypeApi) {
    SearchFiltersProjectTypeApi["FIXED"] = "fixed";
    SearchFiltersProjectTypeApi["HOURLY"] = "hourly";
})(SearchFiltersProjectTypeApi || (SearchFiltersProjectTypeApi = {}));
export var SearchFiltersProjectUpgradeApi;
(function (SearchFiltersProjectUpgradeApi) {
    SearchFiltersProjectUpgradeApi["FEATURED"] = "featured";
    SearchFiltersProjectUpgradeApi["SEALED"] = "sealed";
    SearchFiltersProjectUpgradeApi["NDA"] = "nda";
    SearchFiltersProjectUpgradeApi["URGENT"] = "urgent";
    SearchFiltersProjectUpgradeApi["FULLTIME"] = "fulltime";
    SearchFiltersProjectUpgradeApi["ASSISTED"] = "assisted";
    SearchFiltersProjectUpgradeApi["IP_AGREEMENT"] = "ip_agreement";
})(SearchFiltersProjectUpgradeApi || (SearchFiltersProjectUpgradeApi = {}));
export var SearchFiltersContestUpgradeApi;
(function (SearchFiltersContestUpgradeApi) {
    SearchFiltersContestUpgradeApi["FEATURED"] = "featured";
    SearchFiltersContestUpgradeApi["SEALED"] = "sealed";
    SearchFiltersContestUpgradeApi["HIGHLIGHT"] = "highlight";
    SearchFiltersContestUpgradeApi["GUARANTEED"] = "guaranteed";
    SearchFiltersContestUpgradeApi["TOP_CONTEST"] = "top_contest";
    SearchFiltersContestUpgradeApi["NDA"] = "nda";
    SearchFiltersContestUpgradeApi["URGENT"] = "urgent";
})(SearchFiltersContestUpgradeApi || (SearchFiltersContestUpgradeApi = {}));
export var ContractTypeApi;
(function (ContractTypeApi) {
    ContractTypeApi["IP"] = "ip";
    ContractTypeApi["NDA"] = "nda";
    ContractTypeApi["CLIENT_AGREEMENT"] = "client_agreement";
    ContractTypeApi["ATO_NO_ABN_REQUIRED_DECLARATION"] = "ato_no_abn_required_declaration";
})(ContractTypeApi || (ContractTypeApi = {}));
export var ContractContextTypeApi;
(function (ContractContextTypeApi) {
    ContractContextTypeApi["PROJECT"] = "project";
    ContractContextTypeApi["USER"] = "user";
})(ContractContextTypeApi || (ContractContextTypeApi = {}));
export var InvitationStatusApi;
(function (InvitationStatusApi) {
    InvitationStatusApi["PENDING"] = "pending";
    InvitationStatusApi["ACCEPTED"] = "accepted";
    InvitationStatusApi["LINK_OPEN"] = "link_open";
    InvitationStatusApi["LINK_CLOSED"] = "link_closed";
    InvitationStatusApi["CANCELLED"] = "cancelled";
})(InvitationStatusApi || (InvitationStatusApi = {}));
export var InvitationEntityTypeApi;
(function (InvitationEntityTypeApi) {
    InvitationEntityTypeApi["USER"] = "user";
    InvitationEntityTypeApi["RESTRICTED_LINK"] = "restricted_link";
    InvitationEntityTypeApi["OPEN_LINK"] = "open_link";
})(InvitationEntityTypeApi || (InvitationEntityTypeApi = {}));
export var InvitationTypeApi;
(function (InvitationTypeApi) {
    InvitationTypeApi["PAYMENT_SHARING"] = "payment_sharing";
    InvitationTypeApi["PROJECT_COLLABORATION"] = "project_collaboration";
    InvitationTypeApi["GROUP"] = "group";
    InvitationTypeApi["QUOTATION"] = "quotation";
    InvitationTypeApi["ENTERPRISE"] = "enterprise";
    InvitationTypeApi["TASKLIST"] = "tasklist";
})(InvitationTypeApi || (InvitationTypeApi = {}));
export var InvitationBlockStatusApi;
(function (InvitationBlockStatusApi) {
    InvitationBlockStatusApi["INACTIVE"] = "inactive";
    InvitationBlockStatusApi["ACTIVE"] = "active";
})(InvitationBlockStatusApi || (InvitationBlockStatusApi = {}));
export var InvitationEmailActionApi;
(function (InvitationEmailActionApi) {
    InvitationEmailActionApi["REPORT_SPAM"] = "report_spam";
    InvitationEmailActionApi["ACCEPT_INVITATION"] = "accept_invitation";
})(InvitationEmailActionApi || (InvitationEmailActionApi = {}));
export var UserSettingContextApi;
(function (UserSettingContextApi) {
    UserSettingContextApi["NEWSFEED"] = "newsfeed";
    UserSettingContextApi["THREAD"] = "thread";
    UserSettingContextApi["AI_AUTO_REPLY"] = "ai_auto_reply";
})(UserSettingContextApi || (UserSettingContextApi = {}));
export var UserSettingTargetApi;
(function (UserSettingTargetApi) {
    UserSettingTargetApi["GROUP"] = "group";
    UserSettingTargetApi["PROJECT"] = "project";
    UserSettingTargetApi["THREAD"] = "thread";
})(UserSettingTargetApi || (UserSettingTargetApi = {}));
export var UserSettingValueApi;
(function (UserSettingValueApi) {
    UserSettingValueApi["ACTIVE"] = "active";
    UserSettingValueApi["MUTE"] = "mute";
    UserSettingValueApi["DAILY"] = "daily";
    UserSettingValueApi["ENABLED"] = "enabled";
    UserSettingValueApi["DISABLED"] = "disabled";
    UserSettingValueApi["UNSET"] = "unset";
})(UserSettingValueApi || (UserSettingValueApi = {}));
export var NotificationSettingTargetApi;
(function (NotificationSettingTargetApi) {
    NotificationSettingTargetApi["GROUP"] = "group";
    NotificationSettingTargetApi["PROJECT"] = "project";
    NotificationSettingTargetApi["CONTEST"] = "contest";
    NotificationSettingTargetApi["COMMENT_FEED"] = "comment_feed";
    NotificationSettingTargetApi["POST"] = "post";
    NotificationSettingTargetApi["THREAD"] = "thread";
    NotificationSettingTargetApi["SAVED_SEARCH_PROJECT"] = "saved_search_project";
    NotificationSettingTargetApi["SAVED_SEARCH_LOAD"] = "saved_search_load";
})(NotificationSettingTargetApi || (NotificationSettingTargetApi = {}));
export var NotificationSettingDeliveryTypeApi;
(function (NotificationSettingDeliveryTypeApi) {
    NotificationSettingDeliveryTypeApi["EMAIL"] = "email";
    NotificationSettingDeliveryTypeApi["PUSH_NOTIFICATION"] = "push_notification";
    NotificationSettingDeliveryTypeApi["SMS"] = "sms";
})(NotificationSettingDeliveryTypeApi || (NotificationSettingDeliveryTypeApi = {}));
export var NotificationSettingDigestFrequencyApi;
(function (NotificationSettingDigestFrequencyApi) {
    NotificationSettingDigestFrequencyApi["INSTANT"] = "instant";
    NotificationSettingDigestFrequencyApi["HOURLY"] = "hourly";
    NotificationSettingDigestFrequencyApi["EVERY_3_HOURS"] = "every_3_hours";
    NotificationSettingDigestFrequencyApi["EVERY_6_HOURS"] = "every_6_hours";
    NotificationSettingDigestFrequencyApi["EVERY_12_HOURS"] = "every_12_hours";
    NotificationSettingDigestFrequencyApi["DAILY"] = "daily";
})(NotificationSettingDigestFrequencyApi || (NotificationSettingDigestFrequencyApi = {}));
export var NotificationSettingLogEventSourceTypeApi;
(function (NotificationSettingLogEventSourceTypeApi) {
    NotificationSettingLogEventSourceTypeApi["ADMIN"] = "admin";
    NotificationSettingLogEventSourceTypeApi["USER"] = "user";
    NotificationSettingLogEventSourceTypeApi["SYSTEM"] = "system";
})(NotificationSettingLogEventSourceTypeApi || (NotificationSettingLogEventSourceTypeApi = {}));
export var NotificationSettingValueApi;
(function (NotificationSettingValueApi) {
    NotificationSettingValueApi["NEW_ACTIVITY"] = "new_activity";
    NotificationSettingValueApi["COMMENTS_AND_REPLIES"] = "comments_and_replies";
    NotificationSettingValueApi["MENTIONS"] = "mentions";
    NotificationSettingValueApi["MUTE"] = "mute";
    NotificationSettingValueApi["NEW_POSTS_AND_MENTIONS"] = "new_posts_and_mentions";
    NotificationSettingValueApi["SAVED_SEARCH_MATCH"] = "saved_search_match";
})(NotificationSettingValueApi || (NotificationSettingValueApi = {}));
export var VerificationProcessBenefitApi;
(function (VerificationProcessBenefitApi) {
    VerificationProcessBenefitApi["KYC_APPROVAL"] = "kyc_approval";
})(VerificationProcessBenefitApi || (VerificationProcessBenefitApi = {}));
export const VALID_USER_SETTINGSApi = {
    [UserSettingTargetApi.GROUP]: [
        UserSettingValueApi.ACTIVE,
        UserSettingValueApi.MUTE,
    ],
    [UserSettingTargetApi.PROJECT]: [
        UserSettingValueApi.MUTE,
        UserSettingValueApi.DAILY,
    ],
    [UserSettingTargetApi.THREAD]: [
        UserSettingValueApi.ENABLED,
        UserSettingValueApi.DISABLED,
        UserSettingValueApi.UNSET,
    ],
};
export const DEFAULT_USER_SETTINGSApi = {
    [UserSettingContextApi.NEWSFEED]: {
        [UserSettingTargetApi.GROUP]: UserSettingValueApi.ACTIVE,
    },
    [UserSettingContextApi.THREAD]: {
        [UserSettingTargetApi.PROJECT]: UserSettingValueApi.DAILY,
    },
    [UserSettingContextApi.AI_AUTO_REPLY]: {
        [UserSettingTargetApi.THREAD]: UserSettingValueApi.UNSET,
    },
};
export const VALID_NOTIFICATION_SETTINGSApi = {
    [NotificationSettingTargetApi.GROUP]: [
        NotificationSettingValueApi.NEW_ACTIVITY,
        NotificationSettingValueApi.COMMENTS_AND_REPLIES,
        NotificationSettingValueApi.MENTIONS,
        NotificationSettingValueApi.MUTE,
        NotificationSettingValueApi.NEW_POSTS_AND_MENTIONS,
    ],
    [NotificationSettingTargetApi.PROJECT]: [],
    [NotificationSettingTargetApi.CONTEST]: [],
    [NotificationSettingTargetApi.COMMENT_FEED]: [],
    [NotificationSettingTargetApi.POST]: [],
    [NotificationSettingTargetApi.THREAD]: [],
    [NotificationSettingTargetApi.SAVED_SEARCH_PROJECT]: [
        NotificationSettingValueApi.MUTE,
        NotificationSettingValueApi.SAVED_SEARCH_MATCH,
    ],
    [NotificationSettingTargetApi.SAVED_SEARCH_LOAD]: [
        NotificationSettingValueApi.MUTE,
        NotificationSettingValueApi.SAVED_SEARCH_MATCH,
    ],
};
export const DEFAULT_NOTIFICATION_SETTINGSApi = {
    [NotificationSettingTargetApi.GROUP]: {
        [NotificationSettingDeliveryTypeApi.EMAIL]: NotificationSettingValueApi.NEW_POSTS_AND_MENTIONS,
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.SMS]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.PROJECT]: {
        [NotificationSettingDeliveryTypeApi.EMAIL]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.SMS]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.CONTEST]: {
        [NotificationSettingDeliveryTypeApi.EMAIL]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.SMS]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.COMMENT_FEED]: {
        [NotificationSettingDeliveryTypeApi.EMAIL]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.SMS]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.POST]: {
        [NotificationSettingDeliveryTypeApi.EMAIL]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.SMS]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.THREAD]: {
        [NotificationSettingDeliveryTypeApi.EMAIL]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
        [NotificationSettingDeliveryTypeApi.SMS]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.SAVED_SEARCH_PROJECT]: {
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
    },
    [NotificationSettingTargetApi.SAVED_SEARCH_LOAD]: {
        [NotificationSettingDeliveryTypeApi.PUSH_NOTIFICATION]: NotificationSettingValueApi.MUTE,
    },
};
export var BidPackTypeApi;
(function (BidPackTypeApi) {
    BidPackTypeApi["REGULAR"] = "regular";
})(BidPackTypeApi || (BidPackTypeApi = {}));
export var DirectorySortFieldApi;
(function (DirectorySortFieldApi) {
    DirectorySortFieldApi["HOURLY_RATE"] = "hourly_rate";
    DirectorySortFieldApi["REVIEW_COUNT"] = "review_count";
    DirectorySortFieldApi["RATING"] = "rating";
})(DirectorySortFieldApi || (DirectorySortFieldApi = {}));
export var UserCustomEmailContextApi;
(function (UserCustomEmailContextApi) {
    UserCustomEmailContextApi["PROJECT"] = "project";
})(UserCustomEmailContextApi || (UserCustomEmailContextApi = {}));
export var UserCustomEmailTemplateApi;
(function (UserCustomEmailTemplateApi) {
    UserCustomEmailTemplateApi["DELOITTE_PPMD"] = "deloitte_ppmd";
    UserCustomEmailTemplateApi["DELOITTE_FUNDING_REQUIRED"] = "deloitte_funding_required";
})(UserCustomEmailTemplateApi || (UserCustomEmailTemplateApi = {}));
export var VerificationEligibilityContextApi;
(function (VerificationEligibilityContextApi) {
    VerificationEligibilityContextApi["ENTERPRISE"] = "enterprise";
})(VerificationEligibilityContextApi || (VerificationEligibilityContextApi = {}));
export var DocumentFieldTypeApi;
(function (DocumentFieldTypeApi) {
    DocumentFieldTypeApi["TEXT"] = "text";
    DocumentFieldTypeApi["NUMBER"] = "number";
    DocumentFieldTypeApi["BOOLEAN"] = "boolean";
    DocumentFieldTypeApi["DATE"] = "date";
})(DocumentFieldTypeApi || (DocumentFieldTypeApi = {}));
export var UserDocumentSubmissionNoteVisibilityApi;
(function (UserDocumentSubmissionNoteVisibilityApi) {
    UserDocumentSubmissionNoteVisibilityApi["ADMIN"] = "admin";
    UserDocumentSubmissionNoteVisibilityApi["USER"] = "user";
})(UserDocumentSubmissionNoteVisibilityApi || (UserDocumentSubmissionNoteVisibilityApi = {}));
export var UserDocumentSubmissionNoteLevelApi;
(function (UserDocumentSubmissionNoteLevelApi) {
    UserDocumentSubmissionNoteLevelApi["INFO"] = "info";
    UserDocumentSubmissionNoteLevelApi["WARNING"] = "warning";
    UserDocumentSubmissionNoteLevelApi["ERROR"] = "error";
})(UserDocumentSubmissionNoteLevelApi || (UserDocumentSubmissionNoteLevelApi = {}));
export var UserDocumentApproverAcountTypeApi;
(function (UserDocumentApproverAcountTypeApi) {
    UserDocumentApproverAcountTypeApi["ADMIN"] = "admin";
})(UserDocumentApproverAcountTypeApi || (UserDocumentApproverAcountTypeApi = {}));
export var UserDocumentSubmissionStatusApi;
(function (UserDocumentSubmissionStatusApi) {
    UserDocumentSubmissionStatusApi["UPLOADED"] = "uploaded";
    UserDocumentSubmissionStatusApi["IN_REVIEW"] = "in_review";
    UserDocumentSubmissionStatusApi["ACTIVE"] = "active";
    UserDocumentSubmissionStatusApi["REJECTED"] = "rejected";
    UserDocumentSubmissionStatusApi["EXPIRED"] = "expired";
})(UserDocumentSubmissionStatusApi || (UserDocumentSubmissionStatusApi = {}));
export var UserVerificationProcessStatusApi;
(function (UserVerificationProcessStatusApi) {
    UserVerificationProcessStatusApi["PENDING_REVIEW"] = "pending_review";
    UserVerificationProcessStatusApi["PENDING_USER_ACTION"] = "pending_user_action";
    UserVerificationProcessStatusApi["ACTIVE"] = "active";
})(UserVerificationProcessStatusApi || (UserVerificationProcessStatusApi = {}));
export var UserVerificationAdminReviewActionApi;
(function (UserVerificationAdminReviewActionApi) {
    UserVerificationAdminReviewActionApi["ACCEPT"] = "accept";
    UserVerificationAdminReviewActionApi["REJECT"] = "reject";
})(UserVerificationAdminReviewActionApi || (UserVerificationAdminReviewActionApi = {}));
export var RisingStarUserStatusApi;
(function (RisingStarUserStatusApi) {
    RisingStarUserStatusApi["PENDING"] = "pending";
    RisingStarUserStatusApi["ACCEPTED"] = "accepted";
    RisingStarUserStatusApi["REJECTED"] = "rejected";
    RisingStarUserStatusApi["REMOVED"] = "removed";
})(RisingStarUserStatusApi || (RisingStarUserStatusApi = {}));
export var UserAccountClosureRequestOriginApi;
(function (UserAccountClosureRequestOriginApi) {
    UserAccountClosureRequestOriginApi["CLOSE_ACCOUNT_MODAL"] = "close_account_modal";
})(UserAccountClosureRequestOriginApi || (UserAccountClosureRequestOriginApi = {}));
export var CoverImageStatusApi;
(function (CoverImageStatusApi) {
    CoverImageStatusApi["CURRENT"] = "current";
    CoverImageStatusApi["PREVIOUS"] = "previous";
    CoverImageStatusApi["OLD"] = "old";
})(CoverImageStatusApi || (CoverImageStatusApi = {}));
export var CoverImageContextTypeApi;
(function (CoverImageContextTypeApi) {
    CoverImageContextTypeApi["GROUP"] = "group";
    CoverImageContextTypeApi["USER_PROFILE"] = "user_profile";
})(CoverImageContextTypeApi || (CoverImageContextTypeApi = {}));
export var DiscoverCollectionSortFieldApi;
(function (DiscoverCollectionSortFieldApi) {
    DiscoverCollectionSortFieldApi["COLLECTION_LAST_UPDATED"] = "collection_last_updated";
    DiscoverCollectionSortFieldApi["COLLECTION_NAME"] = "collection_name";
})(DiscoverCollectionSortFieldApi || (DiscoverCollectionSortFieldApi = {}));
export var TeamInvitationStatusApi;
(function (TeamInvitationStatusApi) {
    TeamInvitationStatusApi["PENDING"] = "pending";
    TeamInvitationStatusApi["ACCEPTED"] = "accepted";
    TeamInvitationStatusApi["REJECTED"] = "rejected";
    TeamInvitationStatusApi["DELETED"] = "deleted";
})(TeamInvitationStatusApi || (TeamInvitationStatusApi = {}));
export var MarketingMobileNumberRestrictionCodeApi;
(function (MarketingMobileNumberRestrictionCodeApi) {
    MarketingMobileNumberRestrictionCodeApi["USER_HAS_NO_MEMBERSHIP"] = "user_has_no_membership";
    MarketingMobileNumberRestrictionCodeApi["USER_HAS_NUMBER_RESTRICTION_PENALTY"] = "user_has_number_restriction_penalty";
    MarketingMobileNumberRestrictionCodeApi["USER_HAS_FIRST_WARNING_MODAL_PENALTY"] = "user_has_first_warning_modal_penalty";
    MarketingMobileNumberRestrictionCodeApi["USER_HAS_SECOND_WARNING_MODAL_PENALTY"] = "user_has_second_warning_modal_penalty";
    MarketingMobileNumberRestrictionCodeApi["USER_HAS_FULL_RESTRICTION_PENALTY"] = "user_has_full_restriction_penalty";
})(MarketingMobileNumberRestrictionCodeApi || (MarketingMobileNumberRestrictionCodeApi = {}));
export var UserAvailabilityStatusApi;
(function (UserAvailabilityStatusApi) {
    UserAvailabilityStatusApi["ACTIVE"] = "active";
    UserAvailabilityStatusApi["INACTIVE"] = "inactive";
})(UserAvailabilityStatusApi || (UserAvailabilityStatusApi = {}));
export var ProfileStatusApi;
(function (ProfileStatusApi) {
    ProfileStatusApi["DRAFT"] = "draft";
    ProfileStatusApi["ACTIVE"] = "active";
    ProfileStatusApi["HIDDEN"] = "hidden";
    ProfileStatusApi["REPORTED"] = "reported";
    ProfileStatusApi["DELETED"] = "deleted";
})(ProfileStatusApi || (ProfileStatusApi = {}));
export var AiPromptContextTypeApi;
(function (AiPromptContextTypeApi) {
    AiPromptContextTypeApi["SUPPORT"] = "support";
    AiPromptContextTypeApi["MODERATOR"] = "moderator";
})(AiPromptContextTypeApi || (AiPromptContextTypeApi = {}));
export var AiPromptCreatorTypeApi;
(function (AiPromptCreatorTypeApi) {
    AiPromptCreatorTypeApi["ADMIN"] = "admin";
})(AiPromptCreatorTypeApi || (AiPromptCreatorTypeApi = {}));
